import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fmtRM, BRAND_LABELS } from "@/lib/api";
import { waLink, WhatsAppIcon } from "@/lib/whatsapp";

export default function ModelCard({ model, onView, index = 0 }) {
  return (
    <motion.article
      data-testid={`model-card-${model.brand}-${model.name.toLowerCase().replace(/\s+/g, "-")}`}
      className="group relative flex min-w-0 flex-col overflow-hidden border border-black/10 bg-white transition-colors hover:border-black"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <button
        data-testid={`model-view-${model.id}`}
        onClick={() => onView(model)}
        className="relative block aspect-[4/3] w-full overflow-hidden bg-neutral-100 text-left"
      >
        <img
          src={model.image}
          alt={`${BRAND_LABELS[model.brand]} ${model.name}`}
          loading="lazy"
          className="img-bw h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {model.badge && (
          <span className="absolute left-0 top-0 bg-red-600 px-3 py-1.5 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-black">
            {model.badge}
          </span>
        )}
        <span className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center bg-white text-black opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </button>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center justify-between font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500">
          <span>{BRAND_LABELS[model.brand]}</span>
          <span>{model.body_type}</span>
        </div>
        <h3 className="mt-2 font-display text-2xl font-bold tracking-tight">
          {BRAND_LABELS[model.brand]} {model.name}
        </h3>
        <p className="mt-1 text-sm text-neutral-500">{model.tagline}</p>
        <div className="mt-5 border-t border-black/10 pt-5">
          <div className="flex items-end justify-between">
            <div>
              <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-400">From</div>
              <div className="mt-1 whitespace-nowrap font-display text-xl font-extrabold">{fmtRM(model.price_from)}</div>
            </div>
          </div>
          <div className="mt-4 flex gap-2">
            <a
              href={waLink(`Hi AutoWorld! I'm interested in the ${BRAND_LABELS[model.brand]} ${model.name} (${fmtRM(model.price_from)}). Can I get the best direct price?`)}
              target="_blank"
              rel="noreferrer"
              data-testid={`model-whatsapp-${model.id}`}
              aria-label={`Enquire about ${model.name} on WhatsApp`}
              className="flex h-12 w-12 shrink-0 items-center justify-center border border-black transition-colors hover:bg-black hover:text-white"
              onClick={(e) => e.stopPropagation()}
            >
              <WhatsAppIcon className="h-4 w-4" />
            </a>
            <button
              data-testid={`model-specs-${model.id}`}
              onClick={() => onView(model)}
              className="flex h-12 flex-1 items-center justify-center bg-black px-5 font-mono text-[10px] uppercase tracking-[0.2em] text-white transition-colors hover:bg-neutral-800"
            >
              {model.official_url ? "Details" : "Specs"}
            </button>
          </div>
        </div>
      </div>
    </motion.article>
  );
}
